// extracted by mini-css-extract-plugin
export default {"header":"ChecklistInventoryForm_header__tyKz9","iconDelete":"ChecklistInventoryForm_iconDelete__Ffl-V","iconEdit":"ChecklistInventoryForm_iconEdit__3OChQ"};